import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { isEmpty } from "lodash";
import { addCustomer } from "./Customer.action";
import { setHeading } from "../../../accounts/account.actions";
import { GlobalSpinner, showSuccessAlert, showErrorAlert } from "../../../../../global/globalFunctions";
import { GetLevelAccountTypeApi } from "../../AccountsModule/LevelFour/LevelFourAction";
import { useTranslation } from "react-i18next";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';
import Select from "react-select";


const AddCustomer = (props) => {
  const { t } = useTranslation();
  const [customer, setCustomer] = useState("");
  const [customerCnic, setCustomerCnic] = useState();
  const [customerPhone, setCustomerPhone] = useState();
  const [customerAddress, setCustomerAddress] = useState("");
  const [balance, setBalance] = useState(0);
  const [filerStatus, setFilerStatus] = useState(true);
  const [accountTypeId, setAccountTypeId] = useState();
  const [accountTypeName, setAccountTypeName] = useState();


  function uploadCustomer() {
    props.addCustomer({
      name: customer,
      phone: customerPhone,
      address: customerAddress,
      email: customerCnic,
      debitCreditId: accountTypeId,
      balance: Number(balance),
      filerStatus: filerStatus,
    },
      showSuccessAlert,
      showErrorAlert
    );
    setCustomer("")
    setCustomerCnic("")
    setCustomerPhone("")
    setCustomerAddress("")
    setBalance(0)
    setFilerStatus("")
    setAccountTypeName("")
    setAccountTypeId("")
  }

  const getStatusList = [
    { value: true, label: "Active" },
    { value: false, label: "Non Active" },
  ];
  const handleChangeStatus = (selectedOption) => {
    setFilerStatus(selectedOption.value);
  };

  const handleChangeAccountType = (selectedOption) => {
    setAccountTypeId(selectedOption.value);
    setAccountTypeName(selectedOption.label);
  };
  const getAccountTypeList = !isEmpty(props.accountTypeList) && props.accountTypeList.map((x) => {
    let data = { value: x._id, label: x.account_type_name };
    return data;
  });

  useEffect(() => {
    props.setHeading("Add Customer");
    props.GetLevelAccountTypeApi();
  }, []);

  return (
    <>
      {props.isAddingCustomer || props.isFetchingAccountType ? (
        <GlobalSpinner />
      ) : (
        <Container fluid>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>{t("CustomerName")} *</b></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Customer Name"
                  onChange={(e) => setCustomer(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>{t("OutstandingBalance")} *</b></Form.Label>
                <Form.Control
                  type="number"
                  value={balance}
                  placeholder="Outstanding Balance"
                  min={0}
                  onChange={(e) => { setBalance(e.target.value) }}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>{t("BalanceType")} *</b></Form.Label>
                <Select
                  placeholder="Balance Type"
                  onChange={handleChangeAccountType}
                  options={getAccountTypeList}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>{t("CustomerPhone")} </b></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Customer Phone"
                  value={customerPhone}
                  onChange={(e) => setCustomerPhone(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>{t("CustomerEmail")} </b></Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Customer Email"
                  onChange={(e) => { setCustomerCnic(e.target.value); }}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>{t("CustomerAddress")} </b></Form.Label>
                <Form.Control
                  type="text"
                  value={customerAddress}
                  placeholder="Customer Address"
                  onChange={(e) => setCustomerAddress(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>{t("SelectFilerStatus")} *</b></Form.Label>
                <Select
                  placeholder="Select Filer Status"
                  onChange={handleChangeStatus}
                  options={getStatusList}
                />
              </Form.Group>
            </Col>
            <Col></Col>
          </Row>

          <div className="sendDiv">
            {isEmpty(customer) || isEmpty(accountTypeName) ? (
              <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE </Button>
            ) : (
              <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={uploadCustomer}> SAVE</Button>
            )}
          </div>

        </Container>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    addCustomer: (data, showSuccessAlert, showErrorAlert) => dispatch(addCustomer(data, showSuccessAlert, showErrorAlert)),
    setHeading: (data) => dispatch(setHeading(data)),
    GetLevelAccountTypeApi: () => dispatch(GetLevelAccountTypeApi()),
  };
};
const mapStateToProps = (state, ownProps) => ({
  customerList: state.CustomerReducer.customerList,
  isAddingCustomer: state.CustomerReducer.isAddingCustomer,
  isFetchingAccountType: state.LevelFourReducer.isFetchingAccountType,
  accountTypeList: state.LevelFourReducer.accountTypeList,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddCustomer);